import React from 'react';
import styled from 'styled-components';
import { colors, transition } from '../../../utils/styles';

import { translate } from '../../../../i18n';
import { LinkButton } from '../../commons';
import SectionWrapper from '../../products/events/SectionWrapper';

import customizeCard1x from '../../../images/products/membership/customizeCard1x.png';
import customizeCard2x from '../../../images/products/membership/customizeCard2x.png';
import customizeCard3x from '../../../images/products/membership/customizeCard3x.png';
import mobcustomizeCard1x from '../../../images/products/membership/mobcustomizeCard1x.png';
import mobcustomizeCard2x from '../../../images/products/membership/mobcustomizeCard2x.png';
import mobcustomizeCard3x from '../../../images/products/membership/mobcustomizeCard3x.png';
import ProductIntroduce from '../events/ProductIntroduce';

const t = translate('components/products/membership/CustomizeCard');

const { GATSBY_MANAGER_URL } = process.env;

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 25px;
  line-height: 1.2;
  font-weight: bold;
  margin: 0 auto;
  width: 100%;
  padding-bottom: 88px;
  text-transform: none;

  @media (max-width: 900px) {
    width: 80%;
    padding-bottom: 0px;
    font-size: 20px;
  }
`;

const SectionInformation = styled.div`
  text-align: center;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 auto;
  width: 60%;

  @media (max-width: 900px) {
    width: 90%;
    font-size: 12px;
  }
`;

const ProductDescription = styled.div`
  font-size: 12px;
  line-height: 1.6;
  width: 95%;
  margin: 10px auto 30px;
  text-align: center;

  @media (min-width: 901px) {
    font-size: 15px;
    margin: 20px auto 30px;
  }
`;

const CustomizeCardForm = styled.img`
  width: 100%;
  object-fit: contain;
`;

const CustomizeCardFormSrcSet = styled.picture`
  width: 100%;
  object-fit: contain;
`;

const CenterImg = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
`;

const ImageWrapper = styled.div``;
const TryItButton = styled.a`
  background-color: #31425c;
  border-radius: 10px;
  padding: 0.9em 20px;
  color: white;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 120px;
  text-align: center;
  transform: translateY(60px);

  @media (max-width: 1200px) {
    transform: translateY(50px);
  }

  @media (max-width: 1000px) {
    transform: translateY(40px);
  }

  @media (max-width: 780px) {
    transform: translateY(30px);
  }

  @media (max-width: 600px) {
    transform: translateY(50px);
  }

  @media (max-width: 360px) {
    transform: translateY(40px);
  }
`;

const LinkButtonPosChange = styled(LinkButton)`
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 240px;
  padding: 16px 44px;
  position: absolute;
  top: -130px;
  left: 50%;
  right: 50%;
  margin-left: -120px;

  @media (max-width: 1100px) {
    top: -120px;
  }

  @media (max-width: 1000px) {
    top: -110px;
  }

  @media (max-width: 850px) {
    top: -105px;
  }

  @media (max-width: 800px) {
    padding: 12px 44px;
    top: -95px;
  }

  @media (max-width: 700px) {
    padding: 10px 44px;
    top: -85px;
  }

  @media (max-width: 600px) {
    padding: 16px 44px;
    top: -150px;
  }

  @media (max-width: 480px) {
    padding: 16px 44px;
    top: -140px;
  }

  @media (max-width: 420px) {
    padding: 16px 44px;
    top: -130px;
  }

  @media (max-width: 400px) {
    padding: 16px 44px;
    top: -120px;
  }

  @media (max-width: 360px) {
    padding: 16px 44px;
    top: -110px;
  }
`;

export default ({ source }) => (
  <SectionWrapper zindex={ 800 }>
    <ProductIntroduce
      fontSizeMob='20'
      title={ t('Customizable membership card') }
    />

    <ProductDescription>
      { t(
        'Every club needs a great looking card, and on Juven anyone can be a designer.'
      ) }
    </ProductDescription>

    { /* <CustomizeCardForm
      src={ customizeCard2x }
      srcSet={ `${ mobcustomizeCard1x } 500w, ${ customizeCard2x } 900w, ${ customizeCard3x } 1200w` }
    /> */ }

    <TryItButton
      id={ `${ source }_custom_card_try_it_cta` }
      href={ `${ GATSBY_MANAGER_URL }/signup` }
    >
      { t('Try it now!') }
    </TryItButton>

    <ImageWrapper>
      <CustomizeCardFormSrcSet>
        <source media='(max-width: 600px)' srcSet={ mobcustomizeCard2x } />
        <source media='(max-width: 900px)' srcSet={ customizeCard2x } />
        <source media='(min-width: 901px)' srcSet={ customizeCard3x } />
        <CenterImg src={ customizeCard2x } />
      </CustomizeCardFormSrcSet>
    </ImageWrapper>

    <LinkButtonPosChange
      css='position: relative;'
      blue
      href={ `${ GATSBY_MANAGER_URL }/signup` }
      text='Create your plan today'
      id={ `${ source }_custom_card_create_plan_cta` }
    />
  </SectionWrapper>
);



// WEBPACK FOOTER //
// ./src/components/products/membership/CustomizeCard.js